// For Invoice/Quote PDF

/**
 * To create object for rows (for table) of roof sections and ther componenets if any
 *
 * @param {object} item row details/values
 * @param {number} optional flag for optional rows
 * @returns jsx of row
 */
const getRow = (item, optional = false) => {
  const row = {
    key: item?.name,
    item: `${item?.itemName}, ${item?.material} ${item?.seamType ? ', ' + item?.seamType : ''}`,
    quantity: Math.ceil(item?.quantity),
    unitPrice: parseFloat(item?.unitPrice)?.toFixed(2),
    totalPrice: parseFloat(item?.totalPrice)?.toFixed(2),
    optional: optional
  };
  return row;
};

/**
 * To create jsx for rows (for table) of roof sections and ther componenets if any
 *
 * @param {object} item row details/values
 * @returns jsx of row
 */

const getRowTemplate = (item, optional) => {
  return (
    <tr key={item?.key} className={optional ? 'pdf-optional-rows' : ''}>
      <td>{item.item}</td>
      <td>{item.quantity}</td>
      <td>{item.unitPrice}</td>
      <td>{item.totalPrice}</td>
    </tr>
  );
};

const getAllRowsTemplate = (items) => {
  const requiredRows = items.filter((item) => item?.optional === false);
  const optionalRows = items.filter((item) => item?.optional === true);
  const rowsTemplate = requiredRows.map((row) => getRowTemplate(row));
  // true means optional
  const optionalRowsTemplate = optionalRows.map((row) => getRowTemplate(row, true));

  return (
    <>
      {rowsTemplate}
      {optionalRowsTemplate.length > 0 && (
        <>
          <tr className="pdf-optional-rows">
            <td colSpan={4} style={{ fontWeight: 'bold' }}>
              Optional Components
            </td>
          </tr>
          {optionalRowsTemplate}
        </>
      )}
    </>
  );
};

/**
 * To create Array of all the rows' jsx for table
 *
 * @param {object} items
 * @returns array of rows' jsx
 */
export const getAllRows = (items) => {
  let rows = [];

  // function to update the rows if the row is already in the rows
  // then just add the quantity and total price to the existing row by adding the values
  const updateRows = (currentRow) => {
    const existingRowIndex = rows.findIndex((r) => r.item === currentRow.item);
    if (existingRowIndex !== -1 && rows[existingRowIndex].unitPrice === currentRow.unitPrice) {
      rows[existingRowIndex].quantity += currentRow.quantity;
      console.log(
        'total pricew before',
        currentRow.item,
        rows[existingRowIndex].totalPrice,
        currentRow.totalPrice
      );
      rows[existingRowIndex].totalPrice = parseFloat(
        +rows[existingRowIndex].totalPrice + +currentRow.totalPrice
      ).toFixed(2);
    } else {
      // if row is not in the rows then just add the row to the rows
      rows.push(currentRow);
    }
  };

  // iterate over the items and create row object for each item
  // this row object is used to create JSX for the row in the table
  for (const item of items) {
    // creates object for row
    // false means it is not an optional row
    // if item is optional then it will be handled separately
    const row = getRow(item, false);
    // if row is already in the rows then just add the quantity
    // and total price to the existing row by adding the values
    updateRows(row);

    // if item has system components then iterate over the system components
    // and create row object for each component
    if (item.systemComponents?.length > 0) {
      for (const comp of item.systemComponents) {
        // in future can remove it from the list and backend as well - todo
        // removing union
        if (comp.itemName?.includes('Union')) continue;
        // making optional ice flags stand out
        if (comp.itemName?.includes('Flag')) {
          updateRows(getRow(comp, true));
          continue;
        }
        updateRows(getRow(comp));
      }
    }
  }

  // sort the rows so that optional rows come after normal rows
  const sortedRows = rows.sort((a, b) => {
    // Optional rows should come after normal rows
    if (a.optional && !b.optional) return 1;
    if (!a.optional && b.optional) return -1;
    return 0;
  });

  // return the rows template
  return getAllRowsTemplate(sortedRows);
};
